// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"276":"96cf3929","523":"ce13999d","637":"98b8117a","646":"627f2e88","654":"9b82d26c","796":"9f60b086","920":"e1aaa49d"}[chunkId] + ".chunk.js";
};